import { MUTATION_SET_AVAILABLE_SYMBOLS } from './types';

export default {
  [MUTATION_SET_AVAILABLE_SYMBOLS](state, availableSymbols) {
    state.symbols = availableSymbols;
  },
};
